<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard #wizard [hideTabs]="true">
          <sb-wizard-tab #tab1 titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3 class="my-4">{{'lang.planningEdit.planningDetails' | translate}}</h3>
              <div class="row mb-3">
                <div class="col-md-12">
                  <div class="form-group d-grid">
                    <label class="form-label" for="Company">{{'lang.globals.company' | translate}}</label>
                    <button [disabled]="planning?.forCustomer" (click)="selectCompany()" type="button" id="Company"
                            class="btn btn-secondary  text-center">
                      <sb-icon class="mr-1" icon="company"></sb-icon>
                      {{customer ? customer?.name : ('lang.globals.selectCompany' | translate)}}
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Name">
                    <span class="form-text text-muted">{{'lang.planningEdit.nameDescription' | translate}}</span>
                    <div *ngIf="Name.touched && Name.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
                    <input type="text" id="Description" class="form-control" formControlName="Description">
                    <span class="form-text text-muted">{{'lang.planningEdit.description' | translate}}</span>
                    <div *ngIf="Description.touched && Description.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.description' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="wizard__footerActions">
                <sb-button (click)="util.returnToNavigation(util.RoutingID.plannings)"
                           classes="btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}</sb-button>
                <button (click)="updatePlanningCall()" [disabled]="!form.valid || loading"
                           class="btn btn-success btn-wide btn-lg">{{'lang.globals.submit' | translate}}</button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>

      </div>
    </sb-card>
  </div>
</div>
